function attempt(arg){if(typeof arg==="function"){try{const result=arg();return result instanceof Promise?attempt(result):{data:result}}catch(error){return {error:error}}}return arg.then(data=>({data})).catch(error=>({error:error}))}

export { attempt };
//# sourceMappingURL=Attempt.js.map
